import React from 'react';
import usePartners from './usePartners';

export default function useSleepingPartners(network, schoolStart, schoolEnd, currentTimestamp) {
  return usePartners(network, schoolStart, schoolEnd, {
    sleepingStartingAt: {
      $lte: currentTimestamp
    },
    sleepingEndingAt: {
      $gte: currentTimestamp
    },
    inactive: false
  });
}
